<header class="freemium-premium-confirm-trial-access__header">
    <h2 class="freemium-premium-confirm-trial-access__title">{{'freemium.confirm_trial_access_header' | translate}}</h2>
    <p class="freemium-premium-confirm-trial-access__subtitle">
        {{'freemium.confirm_trial_access_content' | translate}}
    </p>
</header>

<footer class="freemium-premium-confirm-trial-access__footer">
    <button (click)="action()" class="freemium-premium-confirm-trial-access__validate-button" data-e2e="freemium-premium-confirm-trial-access-validate">
        <span>{{'freemium.confirm_trial_access_footer' | translate}}</span>
    </button>
</footer>
